export default __webpack_public_path__ + "static/zaru_collages_v6-3-57788869f787de5e9280b11af62b8b7c.png";